import { IntlProvider } from 'react-intl';
import { setLocale } from 'yup';
import * as Yup from 'yup';
import messages from './../../../i18n/base-en';

const getValidationSchema = (intlData: IntlProvider.Props) => {
  const { intl } = new IntlProvider({ ...intlData }, {}).getChildContext();
  const { formatMessage } = intl;

  setLocale({
    mixed: {
      required: formatMessage(messages.required_valid_error)
    },
  });

  const forgot = Yup.object().shape({
    newPassword: Yup.string()
      .matches(/^.{6,}$/, { message: formatMessage(messages.min_length_error,
        { min: 6 }), excludeEmptyString: true })
      .required(),
  });

  return Yup.object().shape({ forgot });

};

export default getValidationSchema;
